import * as React from 'react';
import { useSelector } from 'react-redux';
import { IBaseButtonProps } from '@cian/ui-kit/button/types';
import { FicheringCall, EPageTypes, EPlatformTypes } from '@cian/frontend-newbuilding-call-component';
import { ApplicationContext } from '../../utils';
import { getDeveloper } from '../../selectors/developerV2';
import { useContacts } from './useContacts';
import { mapBuilder, mapSeller } from './utils';

interface ICallProps {
  onShowPhone(developerId: number): void;
  openContactsStyles?: IBaseButtonProps;
  showPhoneStyles?: IBaseButtonProps;
}

export function CallRedesigned({ onShowPhone, openContactsStyles, showPhoneStyles }: ICallProps) {
  const context = React.useContext(ApplicationContext);

  const developer = useSelector(getDeveloper);

  const { builders, sellers } = useContacts();
  const mappedBuilders = React.useMemo(() => builders.map(mapBuilder), [builders]);
  const mappedSellers = React.useMemo(() => sellers.map(mapSeller), [sellers]);

  const handleShowPhone = React.useCallback(() => {
    onShowPhone(developer.id);
  }, [developer, onShowPhone]);

  return (
    <FicheringCall
      pageType={EPageTypes.NewbuildingCard}
      platformType={EPlatformTypes.WebDesktop}
      placeType="developerCardContacts"
      onShowPhoneClick={handleShowPhone}
      httpApi={context.httpApi}
      logger={context.logger}
      showPhoneStyles={showPhoneStyles}
      openContactsStyles={openContactsStyles}
      builders={mappedBuilders}
      sellers={mappedSellers}
    />
  );
}
